import { render, staticRenderFns } from "./Packaging.vue?vue&type=template&id=2886e98e&scoped=true"
import script from "./Packaging.vue?vue&type=script&lang=js"
export * from "./Packaging.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2886e98e",
  null
  
)

export default component.exports